import { prop } from 'ramda';
import { ConsentAwareSearchInsights as SearchInsights } from '../../lib/algolia/initializeInsights';
import { AddToBagFragment, AddToBagInventoryFragment } from '../../generated/types';
import { LookSource } from '../../components/LookTracking';
import { getActiveVariantBy } from '../../lib/getActiveVariantBy';
import { tc } from '../../lib/trackingContext';
import { getVariantClickHistory } from '../../lib/variantClicksHistory';
import { getCookies } from '../useCookies';
import { getUserFromCookies } from '../useUser';
import { AddToBagMutation } from './addToBag.rest';

type TrackAddToBagArgs = {
  activeVariantId: string;
  data: AddToBagMutation;
  size: AddToBagInventoryFragment | null;
  variant: AddToBagFragment;
  curatedLookId?: number;
  curatedLookItemId?: number;
  lookId?: string;
  lookSource?: LookSource;
};

export const trackAddToBag = ({
  activeVariantId,
  data,
  size,
  variant,
  curatedLookId,
  curatedLookItemId,
  lookId,
  lookSource
}: TrackAddToBagArgs) => {
  const { modaAnonymousId } = getCookies();
  const user = getUserFromCookies();
  const activeVariant = getActiveVariantBy(variant, 'id', activeVariantId);

  SearchInsights('convertedObjectIDsAfterSearch', {
    userToken: user.id ?? modaAnonymousId ?? undefined,
    index: variant.index,
    eventName: 'Product Added',
    objectIDs: [variant.objectid],
    queryID: getVariantClickHistory(variant.id)?.queryId ?? variant.queryid
  });

  tc.track('Product Added', {
    addToScopeOnce: {
      variant,
      user,
      activeVariant,
      size,
      products: data?.addToBag?.data?.[0]?.attributes?.cartItems?.map(prop('data'))
    },
    addToTrackingEvent: {
      label: activeVariantId,
      category: [variant.category[0]?.toString(), variant.subcategory[0]?.toString()].join('/'),
      index: variant.index,
      eventType: 'conversion',
      queryID: getVariantClickHistory(variant.id)?.queryId ?? variant.queryid,
      objectID: variant.objectid,
      position: getVariantClickHistory(variant.id)?.position ?? null,
      curated_look_id: curatedLookId ?? null,
      curated_look_item_id: curatedLookItemId ?? null,
      look_id: lookId ?? null,
      look_source: lookSource ?? null
    }
  });
};
